(function ($) {
  $.fn.loadMap = function(opts) {
    var self = this;
    $.ajax({
        url: opts.dataPath,
        dataType: 'json',
        success: function(res) {
          renderMap(res).appendTo(self);
        },
        error: function(xhr, stats, errorThrown) {
          return 'error';
        }
      });
  };

  function renderMap(data) {
    var row = $('<div/>', {
      'class': 'row'
    });
    data.siteMapa.forEach((column) => {
      var col = $('<div/>', {
        'class': 'col col-sm-4 col-xs-12'
      }).appendTo(row);

      column.bloky.forEach((block) => {
        var bl = $('<div/>', {
          'class': 'block'
        }).appendTo(col);

        var title = $('<a/>', {
          'class': 'block-title',
          'href': block.url
        }).appendTo(bl);
        $('<h2/>', {
          'text': block.title
        }).appendTo(title);

        var list = $('<ul/>', {
          'class': 'url-list'
        }).appendTo(bl);

        block.odkazy.forEach((odkaz) => {
          var item = $('<li/>', {
            'class': 'odkaz'
          }).appendTo(list);

          $('<a/>', {
            'text': odkaz.title,
            'href': odkaz.url
          }).appendTo(item);
        });
      });
    });
    return row;
  }
})(jQuery);
